import React, { FC, ReactNode } from "react";

interface AdminRouteProps {
  children: ReactNode;
}

const MiddlewareAdminRoute: FC<AdminRouteProps> = ({ children }) => {
  if (typeof window === "undefined") return;
  const token = localStorage.getItem("token");

  if (!token) {
    typeof window !== "undefined" ? localStorage.clear() : false;
    window.location.href = "/";
    return null;
  }

  return <>{children}</>;
};

export default MiddlewareAdminRoute;
